import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { TroubleReport } from "../../templates/TroubleReport"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { callRequestCreateTroubleWithUploadedPictures } from "@/hooks/useCleaningInfos"
import { useCallbackExecution } from "@/hooks/useCallbackExecution"

export const TroubleReportPage = () => {
    const { cleaningId } = useParams<"cleaningId">()
    assertIsDefined(cleaningId)
    const { token } = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    // sessionStorageからコールバック情報を取得
    const callbackId = location.state?.callbackId
    const callbackType = location.state?.callbackType
    const callbackExecution = useCallbackExecution(
        cleaningId,
        callbackType,
        callbackId
    )

    const handleSubmit = async (input: {
        description: string
        blobs: Blob[]
    }) => {
        const result = await callRequestCreateTroubleWithUploadedPictures(
            token,
            cleaningId,
            input
        )
        await callbackExecution.execute()
        return result
    }

    return (
        <TroubleReport
            operationId={cleaningId}
            troubleReportedPath={`/cleanings/${cleaningId}`}
            skippable={false}
            onSubmit={handleSubmit}
            onClose={() => navigate(-1)}
        />
    )
}
